module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "open": _vm.open
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "assignment-top"
  }, [_c('h3', [_vm._v("\n      " + _vm._s(_vm.$t(("ui.modals." + _vm.title))) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t(("ui.modals." + _vm.subtitle))) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "assignment-content"
  }, [_c('assignment-modal-search-bar', {
    attrs: {
      "placeholder": _vm.searchPlaceholder,
      "shouldFocus": _vm.shouldFocusSearchbar
    },
    on: {
      "search": _vm.search,
      "shouldFocusChange": _vm.setShouldFocus
    }
  }), _vm._v(" "), _vm._l((_vm.filteredCollection), function(element) {
    return _c('assignment-modal-element', {
      key: element,
      attrs: {
        "item": element,
        "displayName": _vm.displayName,
        "assignedCollection": _vm.internalAssignedCollection
      },
      on: {
        "input": _vm.assign
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f1fc8a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/AssignmentModal.vue
// module id = 1833
// module chunks = 0